export class VerificationTestdafFormDto {
    participantNumber: string;
    participantName: string;
    dateOfBirth: string; // yyyy-mm-dd
    examDate: string; // yyyy-mm-dd
    readingTdn: string;
    listeningTdn: string;
    writingTdn: string;
    speakingTdn: string;
    readingScore: string;
    listeningScore: string;
    writingScore: string;
    speakingScore: string;
}
